import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CxAbstractComponent } from '@b2b/components/cms/cx-abstract/cx-abstract-component/cx-abstract.component';
import { CmsComponentPipe } from '@app/b2b/core/cms/pipes/cms-component.pipe';
import { CmsComponent, CX_COMPONENT } from '@app/core/models/atomics.model';
import { B2BUnitService } from '@b2b/features/b2b-unit/core/b2b-unit.service';
import { TranslateModule } from '@ngx-translate/core';
import { map } from 'rxjs';
import { MiniCartComponent } from '@b2b/components/cms/sections/cx-header-section/components/mini-cart/mini-cart.component';
import { SearchBoxComponent } from '@b2b/components/cms/sections/cx-header-section/components/search-box/search-box.component';
import { IconHamburguerComponent } from '@b2b/components/cms/sections/cx-header-section/components/header-mobile/icon-hamburguer/icon-hamburguer.component';
import { ToggleableMenuComponent } from '@b2b/components/cms/sections/cx-header-section/components/header-mobile/toggleable-menu/toggleable-menu.component';
import { CartService } from '@b2b/features/cart/core/cart.service';
import { UserService } from '@app/core/user/user.service';

@Component({
  selector: 'header-mobile',
  templateUrl: './header-mobile.component.html',
  styleUrl: './header-mobile.component.scss',
  imports: [
    CommonModule,
    RouterModule,
    IconHamburguerComponent,
    MiniCartComponent,
    SearchBoxComponent,
    ToggleableMenuComponent,
    CxAbstractComponent,
    CmsComponentPipe,
    TranslateModule,
  ],
})
export class HeaderMobileComponent {
  @Input({ required: true }) components!: CmsComponent[];

  CX_COMPONENT = CX_COMPONENT;

  user$ = this.userService.get();
  cart$ = this.cartService.getCart();

  // Get current B2B unit from store
  b2bUnit$ = this.b2bUnitService.getCurrentB2BUnit().pipe(map(state => state.data));

  constructor(
    private userService: UserService,
    private cartService: CartService,
    private b2bUnitService: B2BUnitService,
  ) {}

  openB2bUnitModal() {
    this.b2bUnitService.showSelectionModal();
  }
}
